import { createApp } from 'vue';
import Mp3ToAacConverter from '@/Components/Mp3ToAacConverter.vue';
import '@styles/app.css';

createApp(Mp3ToAacConverter).mount('#mp3-to-aac-converter');
